import React from "react";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "./ui/accordion";
import { FAQ_ITEMS, FAQ_COPY } from "../data/faq";

/**
 * Visible patient FAQ. Must stay in sync with the FAQPage JSON-LD in SEO.jsx —
 * both read from the same FAQ_ITEMS source.
 */
export const FAQSection = ({ lang = "et" }) => {
  const c = FAQ_COPY[lang] || FAQ_COPY.et;

  return (
    <section className="container-page pb-24" data-testid="faq-section">
      <div className="chip mb-3">{c.tag}</div>
      <h2 className="section-title mb-8">{c.title}</h2>

      <Accordion type="single" collapsible className="max-w-3xl space-y-3">
        {FAQ_ITEMS.map((item) => (
          <AccordionItem
            key={item.id}
            value={item.id}
            data-testid={`faq-item-${item.id}`}
            className="border border-surface-outline/50 rounded-2xl bg-white px-5 data-[state=open]:border-sapphire-300 transition-colors"
          >
            <AccordionTrigger
              data-testid={`faq-trigger-${item.id}`}
              className="text-left text-[15px] font-semibold text-surface-ink hover:no-underline py-5"
            >
              {item.q[lang] || item.q.et}
            </AccordionTrigger>
            <AccordionContent
              data-testid={`faq-answer-${item.id}`}
              className="text-[14px] leading-relaxed text-surface-inkSoft pb-5"
            >
              {item.a[lang] || item.a.et}
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </section>
  );
};

export default FAQSection;
